const { sameRunStyleInTextBodies } = require('../utils');

exports.computeSubscriptFromTextBodies = (textBodies, textSelection) => sameRunStyleInTextBodies(
    textBodies,
    'subscript',
    false,
    {
        textSelection
    }
);
